
















































import { Mixins, Component } from "vue-property-decorator";
import { DialogMixin } from "../../../../../../../base/components/system/mixins";
import { ObjectUtility } from "../../../../../../../base/utilities";

@Component
export default class FilePathEditDialog extends Mixins(DialogMixin) {
  filePath: string = "";
  confirmed: boolean = false;

  async show(filePath: string): Promise<string> {
    return this.showModal(async () => {
      this.filePath = ObjectUtility.copyDeeply(filePath);
      this.confirmed = false;
      await this.waitHidden();
      return this.confirmed ? this.filePath : null;
    });
  }

  insertPatientNo() {
    this.filePath = this.filePath + "%PT_NUM%";
  }

  insertDateTime() {
    this.filePath = this.filePath + "%DATE_TIME%";
  }

  confirm(): void {
    this.confirmed = true;
    this.isVisible = false;
  }

  cancel(): void {
    this.isVisible = false;
  }
}
